import React from 'react';
import { useSelector } from 'react-redux';

import $betting from 'app/contexts/betting/$interesting-matches';
import { GridSkeletons } from 'app/design-system/components/Skeleton/GridSkeleton';
import { useTranslation } from 'app/lang';
import { BettingWrapper } from 'app/modules/Betting';
import { entityLoading } from 'app/modules/LandingPage/InterestingMatches/selectors/entities';

import { SportsGrid } from '../SportGrid';

import dictionary from './PopularMatches.dictionary.json';

import styles from './PopularMatches.module.scss';

export const PopularMatches = () => {
  const { t } = useTranslation();
  const loading = useSelector(entityLoading);

  return (
    <div className={styles.root}>
      <h5 className={styles.title}>{t(dictionary.title)}:</h5>
      {loading ? (
        <GridSkeletons className={styles.skeleton} />
      ) : (
        <BettingWrapper context={$betting}>
          <SportsGrid />
        </BettingWrapper>
      )}
    </div>
  );
};
